import { render, staticRenderFns } from "./FamilyMemberContact.vue?vue&type=template&id=34b5644b&scoped=true"
import script from "./FamilyMemberContact.vue?vue&type=script&lang=js"
export * from "./FamilyMemberContact.vue?vue&type=script&lang=js"
import style0 from "./FamilyMemberContact.vue?vue&type=style&index=0&id=34b5644b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5644b",
  null
  
)

export default component.exports